import { icon } from "../functions/icons";
import { HorizontalLayout, VerticalLayout } from "./layout";
import { Chip } from "../molecule/Chip";
import { forwardRef } from "react";
export const CompanyDropdown = forwardRef(({ title , sector , orgNum , children, className, backgroundColor, color, open, toggleOpen }, ref) => {
    
    return (
                        <div ref={ref} className={`dropdown-wrapper ${className}`} style={{ width: "100%", scrollMarginTop: "1rem" }}>
                        <button
                                onClick={toggleOpen}
                                className={`dropdown-toggle ${open ? "active" : ""}`}
                                style={{
                                padding: "0.5rem 1rem",
                                borderRadius: "0.5rem",
                                border: "1px solid var(--grey-200)",
                                backgroundColor: open ? "var(--grey-200)" : "white",
                                cursor: "pointer",
                                width: "100%",
                                borderBottomRightRadius: open ? "unset" : "0.5rem",
                                borderBottomLeftRadius: open ? "unset" : "0.5rem",
                                borderBottom: open ? "unset" : "1px solid var(--grey-200)" ,
                                }}
                        >
                                <HorizontalLayout style={{ justifyContent: "space-between", alignItems: "center", width: "100%", }}>
                                <span className={`dropdown-chevron ${open ? "open" : "closed"}`}>
                                        {icon("chevron-down", 16)}
                                </span>
                                <VerticalLayout style={{ alignItems: "flex-start", gap: "0.2rem", paddingLeft: "0.5rem" }}>
                                        {title}
                                        <span style={{ color: "var(--grey-600)" }}>{sector}</span>
                                </VerticalLayout>
                                <Chip
                                        style={{
                                        backgroundColor: backgroundColor || "var(--primary-500)",
                                        color: color || "white",
                                        whiteSpace: "nowrap",
                                        }}
                                        label={`${orgNum + " organisaties"}`}
                                />
                                </HorizontalLayout>
                        </button>

                        <div
                                className={`dropdown-content ${open ? "active" : ""}`}
                                style={{
                                        border: "1px solid var(--grey-200)",
                                        borderRadius: "0.5rem",
                                        overflow: "hidden",
                                        maxHeight: open ? "1000px" : "0px",
                                        opacity: open ? 1 : 0,
                                        transition: "max-height 0.4s linear, opacity 0.3s linear",
                                        paddingRight: "unset",
                                        borderTopRightRadius: "unset",
                                        borderTopLeftRadius: "unset",
                                }}
                        >
                                {children}
                        </div>

                        </div>
    );
})